
import mixins from "vue-typed-mixins";
import Modal from "@/components/Modal.vue";
import StackingNotification from "@/components/StackingNotification.vue";
import StackingNotificationMixins from "@/mixins/StackingNotificationMixins";
export default mixins(StackingNotificationMixins).extend({
  name: 'DisplayPasscode',
  data:() => ({
    fullUrlPath: ''
  }),
  components: {
    StackingNotification,
    Modal
  },
  methods: {
    closeModal(){
      this.$emit('closeModal');
    },
    copyUrlPathToClipboard(){
      navigator.clipboard.writeText(this.fullUrlPath);
      this.addNotification({
        message: 'Url Copied To Clipboard'
      });
    }
  },
  mounted(){
    const barrelId = this.$route.params.barrelId;
    this.fullUrlPath = `${window.location.origin}/document/${barrelId}`;
  }
})
